import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../../../common/shared.module';
import { TableComponent } from '../../../../common/components/table/table.component';
import { TableColumnDirective } from '../../../../common/directives/table-column.directive';
import { TableContainerComponent } from '../../../../common/components/table-container/table-container.component';
import { SwalService } from '../../../../common/services/swal.service';
import { CoveragesService } from '../../../insurance-types/services/coverages.service';
import { CoverageListDto } from '../../../../core/data/new-dtos/insurance-type.dtos';
import TableHeader from '../../../../common/interfaces/table/tableHeader';
import { lastValueFrom } from 'rxjs';
import { CoverageModalComponent, CoverageModalResult } from '../coverage-modal/coverage-modal.component';

@Component({
    selector: 'app-coverages-list',
    standalone: true,
    imports: [
        CommonModule,
        SharedModule,
        TableComponent,
        TableColumnDirective,
        TableContainerComponent,
        CoverageModalComponent
    ],
    templateUrl: './coverages-list.component.html',
    styleUrls: ['./coverages-list.component.scss'],
    providers: [SwalService]
})
export class CoveragesListComponent implements OnInit {
    coverages: CoverageListDto[] = [];
    filteredCoverages: CoverageListDto[] = [];
    searchTerm = '';
    tableHeaders: TableHeader[] = [
        { attribute: 'coverageCode', label: 'Código' },
        { attribute: 'name', label: 'Nombre' },
        { attribute: 'description', label: 'Descripción' },
        { attribute: 'actions', label: 'Acciones' }
    ];

    showCoverageModal = false;
    selectedCoverage?: CoverageListDto;

    constructor(
        private swal: SwalService,
        private coveragesService: CoveragesService
    ) { }

    async ngOnInit() {
        await this.refresh();
    }

    async refresh() {
        this.swal.showLoading('Cargando coberturas...');
        try {
            this.coverages = await lastValueFrom(this.coveragesService.getAll());
            this.applyFilter();
        } catch (e) {
            this.coverages = [];
            this.filteredCoverages = [];
            this.swal.error('No se pudieron cargar las coberturas.');
        } finally {
            this.swal.dismiss();
        }
    }

    onSearch(term: string) {
        this.searchTerm = term;
        this.applyFilter();
    }

    private applyFilter() {
        if (!this.searchTerm.trim()) {
            this.filteredCoverages = [...this.coverages];
        } else {
            const lowerTerm = this.searchTerm.toLowerCase();
            this.filteredCoverages = this.coverages.filter(c =>
                c.coverageCode?.toLowerCase().includes(lowerTerm) ||
                c.name?.toLowerCase().includes(lowerTerm)
            );
        }
    }

    openCreateModal() {
        this.selectedCoverage = undefined;
        this.showCoverageModal = true;
    }

    openEditModal(id: number) {
        this.selectedCoverage = this.coverages.find(c => c.id === id);
        if (this.selectedCoverage) {
            this.showCoverageModal = true;
        }
    }

    async onCoverageModalClosed(result: CoverageModalResult) {
        this.showCoverageModal = false;

        if (result.action === 'save' && result.data) {
            this.swal.showLoading('Guardando cobertura...');
            try {
                if (this.selectedCoverage) {
                    await lastValueFrom(this.coveragesService.update(this.selectedCoverage.id, result.data as any));
                    await this.swal.success('Cobertura actualizada.');
                } else {
                    await lastValueFrom(this.coveragesService.create(result.data as any));
                    await this.swal.success('Cobertura creada.');
                }
                await this.refresh();
            } catch (e) {
                this.swal.error('No se pudo guardar la cobertura.');
            }
        }
    }
}
